import apiClient from './apiClient';
import { GET_TRANSACTION_ALL_BY_STATUS_URL } from './apiUrl';
const getTransactionAllByStatusApi = status => {
  return apiClient.get(GET_TRANSACTION_ALL_BY_STATUS_URL(status));
};

export default getTransactionAllByStatusApi;
